import type { FC } from "react";

export const CategoryGridSkeleton: FC = function () {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 animate-pulse">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <div
          key={i}
          className="h-24 bg-surface-muted rounded-lg"
        ></div>
      ))}
    </div>
  );
};
